import React, { useEffect, useState } from "react";
import { Col, Row } from 'antd';
import CardContainer from "../../../../commons/components/cardContainer";
import ServiceOffice from "../../../../services/offices";
import Loading from "../../../../commons/components/loading";
import AccountModal from "../../../../commons/components/AccountModal"
import AccountSelectOption from "../../../../commons/components/AccountSelectOption";
import AccountInput from "../../../../commons/components/AccountInput/index";
import RoundButton from "../../../../commons/components/RoundButton";

export default props => {

    const [statusEdit, setStatusEdit] = useState(false);

    const [officeDepData, setOfficeDepData] = useState({ custom_office: null, custom_dep: null });

    const [officeList, setOfficeList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);

    const [errorSelectPartner, setErrorSelectPartner] = useState();

    const [errorSelectOffice, setErrorSelectOffice] = useState("");
    const [errorInputOffice, setErrorInputOffice] = useState("");

    const [errorSelectDepartment, setErrorSelectDepartment] = useState("");
    const [errorInputDepartment, setErrorInputDepartment] = useState("");

    const [loading, setLoading] = useState(false);

    const [showModalDelete, setShowModalDelete] = useState(false);

    useEffect(() => {
        if(props.item) {
            setOfficeDepData(props.item);
        } else {
            setOfficeDepData({ 
                ...officeDepData,
                id_user: props.user, 
                id_partner: props.partnerList[0].value
            })
        }

        setOfficeList(putOtherOptionAtLast(props.officeList))
        setDepartmentList(putOtherOptionAtLast(props.depList))
    }, [props]);

    function putOtherOptionAtLast(data = []) {
        data = data.filter(element => element.label !== 'OUTRO');
        data.push({ value: 0, label: 'OUTRO' });

        return data
    }

    function isFormValid() {
        let valid = true;
    
        if (!officeDepData.id_office && officeDepData.id_office !== 0) {
            valid = false;
            setErrorSelectOffice("Favor informar um cargo");
        }
    
        if (!officeDepData.id_dep && officeDepData.id_dep !== 0) {
            valid = false;
            setErrorSelectDepartment("Favor informar um setor");
        }

        if(officeDepData.id_office === 0) {
            if(officeDepData.custom_office === '') {
                valid = false;
                setErrorInputOffice("Favor informar um cargo");
            } else if(officeDepData.custom_office.length < 3) {
                valid = false;
                setErrorInputOffice("Favor informar um cargo com mais de 3 letras");
            }
        }

        if(officeDepData.id_dep === 0) {
            if(officeDepData.custom_dep === '') {
                valid = false;
                setErrorInputDepartment("Favor informar um departamento");
            } else if(officeDepData.custom_dep.length < 3) {
                valid = false;
                setErrorInputDepartment("Favor informar um departamento com mais de 3 letras");
            }
        }

        return valid;
    }

    function canSave() {
        if (isFormValid()) {
            save(officeDepData);
        }
    }

    function pegaEdit() {
        return props.canEdit;
    }

    async function inactivate() {
        let data = { "id": props.item.id };
        let response = await ServiceOffice.inactivate(data);
        if (response) {
            setLoading(false);
            stopEdit();
            props.reload();
        }
    }

    function handleOnChangeDataObject(key, value) {
        setOfficeDepData({ ...officeDepData, [key]: value });
    }

    async function save(data) {
        setLoading(true);

        delete data.trading_name

        if (props.item) {
            let ids = { "id": props.item.id, "id_partner": props.item.id_partner };
            data = Object.assign(data, ids);
        }
        
        ServiceOffice.insert(data)
            .then(() => {})
            .catch(() => {})
            .finally(res => {
                setLoading(false);
                stopEdit();
                props.reload();
            });
    }

    function getStatusEdit() {
        return statusEdit || props.creating;
    }

    function startEdit() {
        setStatusEdit(true);
        props.editing(true);
    }

    function stopEdit() {
        setStatusEdit(false);
        props.editing(false);
    }

    function handleOnChangePartner(partner_id) {
        handleOnChangeDataObject('id_partner', partner_id);
        setErrorSelectPartner("")
    }

    function handleCancelDeleteOffice() {
        setShowModalDelete(false);
    }

    function handleDeleteOffice() {
        setShowModalDelete(true);
    }

    function getOfficeName(id_office) {
        if(id_office) {
            const office = props.officeList.find(item => item.value === id_office);
            return office.label;
        }
        return props.item.custom_office
    }

    function handleOnChangeOffice(id_office) {
        if (id_office === 0) {
            setOfficeDepData({ 
                ...officeDepData, 
                id_office: id_office, 
                custom_office: '' 
            })
        } else {
            setOfficeDepData({ 
                ...officeDepData, 
                id_office: id_office,
                custom_office: null 
            })
        }
        setErrorSelectOffice("")
        setErrorInputOffice("");
    }

    function handleOnChangeInputOffice(office_value) {
        handleOnChangeDataObject('custom_office', office_value.target.value);
        if (office_value.target.value) {
            setErrorInputOffice("");
        } else {
            setErrorInputOffice("Campo obrigatório");
        }
    }

    function getDepartmentName(id_dep) {
        if(id_dep) {
            const department = props.depList.find(item => item.value === id_dep);
            return department.label;
        }
        return props.item.custom_dep
    }

    function handleOnChangeDepartment(id_dep) {
        if (id_dep === 0) {
            setOfficeDepData({ 
                ...officeDepData,
                id_dep: id_dep, 
                custom_dep: '' 
            })
        } else {
            setOfficeDepData({ 
                ...officeDepData,
                id_dep: id_dep, 
                custom_dep: null
            })
        }
        setErrorSelectDepartment("")
        setErrorInputDepartment("");
    }

    function handleOnChangeInputDepartment(dep_value) {
        handleOnChangeDataObject('custom_dep', dep_value.target.value);
        if (dep_value.target.value) {
            setErrorInputDepartment("");
        } else {
            setErrorInputDepartment("Campo obrigatório");
        }
    }

    function renderBotaoExcluir() {
        if (!props.creating) {
            return (
                <>
                    <AccountModal
                        visible={showModalDelete}
                        title="Excluir Cargo"
                        onCancel={handleCancelDeleteOffice}
                        cancelText="Cancelar"
                        onOk={inactivate}
                        okText="Excluir"
                        okType="danger">

                        <p>Tem certeza que deseja remover as informações de sua atuação nesta empresa?</p>
                    </AccountModal>
                    <Col span={1}>
                        <RoundButton text="Não trabalho mais aqui" iconType="delete" onClick={handleDeleteOffice} />
                    </Col>
                </>
            )
        }
    }

    function renderPartner() {
        if (statusEdit || props.creating) {
            return (
                <>
                    {renderPartnerField()}
                    <Col span={statusEdit ? 6 : 5}>
                    </Col>
                    <Col span={1}>
                        <RoundButton text="Salvar" iconType="check" onClick={canSave}/>
                    </Col>
                    <Col span={1}>
                        <RoundButton text="Cancelar" iconType="close" onClick={stopEdit}/>
                    </Col>
                </>
            );
        } else {
            return (
                <>
                    {renderPartnerField()}
                    <Col span={6}>
                    </Col>
                    <Col span={1}>
                        <RoundButton text="Editar" iconType="edit" onClick={startEdit} hidden={!pegaEdit()}/> 
                    </Col>
                    {renderBotaoExcluir()}
                </>
            );
        }
    }

    function renderPartnerField() {
        if (props.creating) {
            return (
                <>
                    <Col span={8}>
                        <AccountSelectOption
                            style={{ marginTop: 16, width: '100%' }}
                            value={officeDepData.id_partner}
                            placeholder="Empresa"
                            data={props.partnerList}
                            disabled={props.partnerList.length === 1 ? true : false}
                            onChange={handleOnChangePartner}
                            allowClear={true}
                            showSearch={true}
                            error={errorSelectPartner}
                        />
                    </Col>
                    <Col span={5}></Col>
                </>
            )
        } else {
            return (
                <Col span={12}>
                    <span className={"account-card-data"}>{props.item.trading_name}</span>
                </Col>
            )
        }
    }

    function renderOffice() {
        if (getStatusEdit()) {
            return (
                <>
                    <Col span={8}>
                        <AccountSelectOption
                            style={{ marginTop: 16, width: '100%' }}
                            value={officeDepData.id_office}
                            placeholder="Cargo (nível)*"
                            data={officeList}
                            onChange={handleOnChangeOffice}
                            allowClear={true}
                            showSearch={true}
                            error={errorSelectOffice}
                        />
                    </Col>
                    <Col span={8}>
                        {officeDepData.id_office === 0 ?
                            <AccountInput
                                style={{ marginTop: 16, width: '100%' }}
                                placeholder="Outro*"
                                value={officeDepData.custom_office}
                                onChange={handleOnChangeInputOffice}
                                error={errorInputOffice}
                            />
                            : null
                        }
                    </Col>
                </>
            );
        } else {
            return (
                <>
                    <Col span={6}>
                        <span className={"account-card-data"}>{getOfficeName(officeDepData.id_office)}</span>
                    </Col>
                    <Col span={14}>
                    </Col>
                </>
            );
        }
    }

    function renderDepartment() {
        if (getStatusEdit()) {
            return (
                <>
                    <Col span={8}>
                        <AccountSelectOption
                            style={{ marginTop: 16, width: '100%' }}
                            value={officeDepData.id_dep}
                            placeholder="Setor*"
                            data={departmentList}
                            onChange={handleOnChangeDepartment}
                            allowClear={true}
                            showSearch={true}
                            error={errorSelectDepartment}
                        />
                    </Col>
                    <Col span={8}>
                        {officeDepData.id_dep === 0 ?
                            <AccountInput
                                style={{ marginTop: 16, width: '100%' }}
                                placeholder="Outro*"
                                value={officeDepData.custom_dep}
                                onChange={handleOnChangeInputDepartment}
                                error={errorInputDepartment}
                            />
                            : null
                        }
                    </Col>
                </>
            );
        } else {
            return (
                <>
                    <Col span={6}>
                        <span className={"account-card-data"}>{getDepartmentName(officeDepData.id_dep)}</span>
                    </Col>
                    <Col span={14}>
                    </Col>
                </>
            );
        }
    }

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", marginTop: 30 }}>
                <Loading width={50} height={50} />
            </div>
        )
    } else {
        return (
            <>
                <CardContainer>
                    <Row gutter={20} className={"profissionais-row"}>
                        <Col span={4}>
                            <span className={"account-card-label"}>Empresa:</span>
                        </Col>
                        {renderPartner()}
                    </Row>
                    <Row gutter={20} className={"profissionais-row"}>
                        <Col span={4}>
                            <span className={"account-card-label"}>Cargo (nível):</span>
                        </Col>
                        {renderOffice()}
                    </Row>
                    <Row gutter={20} className={"profissionais-row-last"}>
                        <Col span={4}>
                            <span className={"account-card-label"}>Setor:</span>
                        </Col>
                        {renderDepartment()}
                    </Row>
                </CardContainer>
            </>
        );
    }
}